export default "__VITE_ASSET__DNnD2ZTp__";